import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { stagingApi } from './stagingSlice';
import { throwErrorMessage } from 'helpers/functions/errors';
import { getOAuth2StartUrl } from 'utils/oauth';

interface RtkQueryErrorPayload {
    status?: number;
    originalStatus?: number;
    data?: {
        errorString?: string;
        message?: string;
        [key: string]: any;
    };
}

export const stagingApiQueryErrorLogger: Middleware = () => next => (action: any) => {
    if (isRejectedWithValue(action) && action.type.startsWith(stagingApi.reducerPath)) {
        const payload = action.payload as RtkQueryErrorPayload;
        const status = payload.originalStatus || payload.status;

        switch (status) {
            case 400:
                throwErrorMessage(400, action, payload.data?.errorString ?? 'Bad Request');
                break;

            case 401:
                throwErrorMessage(401, action, 'Error code: 401');
                location.replace(getOAuth2StartUrl());
                break;

            case 403:
                const endpointName = (action.meta as any)?.arg?.endpointName;
                console.warn(`Type: ${action.type}`);
                console.warn(`We got a rejected action in API! (403) - ${endpointName}`);
                console.warn(payload);
                break;

            case 422:
                throwErrorMessage(422, action, payload.data?.errorString ?? 'Unprocessable Entity');
                break;

            default:
                throwErrorMessage(500, action, 'Internal server error: 500');
                break;
        }
    }

    return next(action);
};
